import script from "./AboutPrimaryComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutPrimaryComponent.vue?vue&type=script&setup=true&lang=js"

import "./AboutPrimaryComponent.vue?vue&type=style&index=0&id=15c1b832&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15c1b832"]])

export default __exports__